import * as React from 'react';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import { cn } from '@/lib/utils';

export const Dialog = DialogPrimitive.Root;
export const DialogTrigger = DialogPrimitive.Trigger;
export const DialogClose = DialogPrimitive.Close;

export function DialogContent({
  className,
  children,
  titulo,
  descricao,
  ...props
}: React.ComponentPropsWithoutRef<typeof DialogPrimitive.Content> & {
  titulo: string;
  descricao?: string;
}) {
  return (
    <DialogPrimitive.Portal>
      <DialogPrimitive.Overlay className="fixed inset-0 z-50 bg-black/45 backdrop-blur-[2px]" />
      <DialogPrimitive.Content
        className={cn(
          'fixed left-1/2 top-1/2 z-50 w-[calc(100vw-2rem)] max-w-lg -translate-x-1/2 -translate-y-1/2',
          // Sem a altura máxima com rolagem, um conteúdo longo (lista de prompts,
          // menu do celular) passa da tela e some — o diálogo é `fixed`.
          'max-h-[90dvh] overflow-y-auto',
          'animate-surgir rounded-lg border border-border bg-card p-5 shadow-xl sm:p-6',
          className,
        )}
        {...props}
      >
        <div className="mb-4 space-y-1 pr-8">
          <DialogPrimitive.Title className="text-lg font-semibold tracking-tight">{titulo}</DialogPrimitive.Title>
          {descricao ? (
            <DialogPrimitive.Description className="text-sm leading-relaxed text-muted-foreground">
              {descricao}
            </DialogPrimitive.Description>
          ) : null}
        </div>
        {children}
        <DialogPrimitive.Close
          aria-label="Fechar"
          className="absolute right-4 top-4 rounded-md p-1 text-muted-foreground transition-colors hover:bg-secondary hover:text-foreground"
        >
          <X className="size-4" />
        </DialogPrimitive.Close>
      </DialogPrimitive.Content>
    </DialogPrimitive.Portal>
  );
}
